/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateDriverRequest
 */
export interface CreateDriverRequest {
    /**
     * ログインID (30文字以内英数記号)
     * @type {string}
     * @memberof CreateDriverRequest
     */
    loginId: string;
    /**
     * パスワード (英大文字・英小文字・数字・記号を組み合わせて20文字以内)
     * @type {string}
     * @memberof CreateDriverRequest
     */
    password?: string;
    /**
     * ドライバー姓 (姓名合計90文字以内)
     * @type {string}
     * @memberof CreateDriverRequest
     */
    driverLastName: string;
    /**
     * ドライバー名 (姓名合計90文字以内)
     * @type {string}
     * @memberof CreateDriverRequest
     */
    driverFirstName: string;
    /**
     * ドライバー姓-カナ (姓名合計90文字以内)
     * @type {string}
     * @memberof CreateDriverRequest
     */
    driverLastNameKana: string;
    /**
     * ドライバー名-カナ (姓名合計90文字以内)
     * @type {string}
     * @memberof CreateDriverRequest
     */
    driverFirstNameKana: string;
    /**
     * ドライバー姓-英字 (姓名合計90文字以内)
     * @type {string}
     * @memberof CreateDriverRequest
     */
    driverLastNameEn: string;
    /**
     * ドライバー名-英字 (姓名合計90文字以内)
     * @type {string}
     * @memberof CreateDriverRequest
     */
    driverFirstNameEn: string;
    /**
     * 性別 (1:男性, 2:女性, 3:指定なし)
     * @type {number}
     * @memberof CreateDriverRequest
     */
    gender: number;
    /**
     * 免許証番号（12桁半角数字ハイフンなし）
     * @type {string}
     * @memberof CreateDriverRequest
     */
    licenseNumber: string;
    /**
     * 免許証有効期限（YYYY/MM/DD形式）
     * @type {string}
     * @memberof CreateDriverRequest
     */
    driverLicenseExpiration: string;
    /**
     * グループコード
     * @type {string}
     * @memberof CreateDriverRequest
     */
    companyCode: string;
    /**
     * 営業所ID
     * @type {string}
     * @memberof CreateDriverRequest
     */
    salesOfficeId?: string;
    /**
     * 配車可否
     * @type {boolean}
     * @memberof CreateDriverRequest
     */
    available?: boolean;
    /**
     * 配車アプリ連携リスト（1:Uber, 2:DiDi）
     * @type {Array<number>}
     * @memberof CreateDriverRequest
     */
    dispatchApps?: Array<number>;
    /**
     * 備考
     * @type {string}
     * @memberof CreateDriverRequest
     */
    description?: string;
}

/**
 * Check if a given object implements the CreateDriverRequest interface.
 */
export function instanceOfCreateDriverRequest(value: object): value is CreateDriverRequest {
    if (!('loginId' in value) || value['loginId'] === undefined) return false;
    if (!('driverLastName' in value) || value['driverLastName'] === undefined) return false;
    if (!('driverFirstName' in value) || value['driverFirstName'] === undefined) return false;
    if (!('driverLastNameKana' in value) || value['driverLastNameKana'] === undefined) return false;
    if (!('driverFirstNameKana' in value) || value['driverFirstNameKana'] === undefined) return false;
    if (!('driverLastNameEn' in value) || value['driverLastNameEn'] === undefined) return false;
    if (!('driverFirstNameEn' in value) || value['driverFirstNameEn'] === undefined) return false;
    if (!('gender' in value) || value['gender'] === undefined) return false;
    if (!('licenseNumber' in value) || value['licenseNumber'] === undefined) return false;
    if (!('driverLicenseExpiration' in value) || value['driverLicenseExpiration'] === undefined) return false;
    if (!('companyCode' in value) || value['companyCode'] === undefined) return false;
    return true;
}

export function CreateDriverRequestFromJSON(json: any): CreateDriverRequest {
    return CreateDriverRequestFromJSONTyped(json, false);
}

export function CreateDriverRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDriverRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'loginId': json['login_id'],
        'password': json['password'] == null ? undefined : json['password'],
        'driverLastName': json['driver_last_name'],
        'driverFirstName': json['driver_first_name'],
        'driverLastNameKana': json['driver_last_name_kana'],
        'driverFirstNameKana': json['driver_first_name_kana'],
        'driverLastNameEn': json['driver_last_name_en'],
        'driverFirstNameEn': json['driver_first_name_en'],
        'gender': json['gender'],
        'licenseNumber': json['license_number'],
        'driverLicenseExpiration': json['driver_license_expiration'],
        'companyCode': json['company_code'],
        'salesOfficeId': json['sales_office_id'] == null ? undefined : json['sales_office_id'],
        'available': json['available'] == null ? undefined : json['available'],
        'dispatchApps': json['dispatch_apps'] == null ? undefined : json['dispatch_apps'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function CreateDriverRequestToJSON(json: any): CreateDriverRequest {
    return CreateDriverRequestToJSONTyped(json, false);
}

export function CreateDriverRequestToJSONTyped(value?: CreateDriverRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'login_id': value['loginId'],
        'password': value['password'],
        'driver_last_name': value['driverLastName'],
        'driver_first_name': value['driverFirstName'],
        'driver_last_name_kana': value['driverLastNameKana'],
        'driver_first_name_kana': value['driverFirstNameKana'],
        'driver_last_name_en': value['driverLastNameEn'],
        'driver_first_name_en': value['driverFirstNameEn'],
        'gender': value['gender'],
        'license_number': value['licenseNumber'],
        'driver_license_expiration': value['driverLicenseExpiration'],
        'company_code': value['companyCode'],
        'sales_office_id': value['salesOfficeId'],
        'available': value['available'],
        'dispatch_apps': value['dispatchApps'],
        'description': value['description'],
    };
}

